import * as React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import Icon from 'common/components/IconFont';
import { Select, Divider, Input } from 'antd';
import StaticView from './StaticView';
const Option = Select.Option;

interface iOption {
    label: string | JSX.Element;
    value: string;
}

export default class SelectExtend extends React.Component<any> {
    static fieldName = 'select';
    static type = 'Select';
    private select: HTMLElement;
    index = 0;
    state = {
        name: '',
        open: false,
        inputOnFocus: false
    };
    /**
     * 值变化控制
     * @param value
     */
    onChangeHandler = (value: any, option?: any) => {
        const { onChange } = this.props;
        if (onChange) onChange(value, option);
    };

    /**
     * 选择控制
     * @param value
     */
    onSelectHandler = (value: any, option?: any) => {
        const { onSelect } = this.props;
        if (onSelect) onSelect(value, option);
        this.setState({ open: false });
    };
    /**
    * 取消选择控制
    * @param value
    */
    onDeselectHandler = (value: any, option?: any) => {
        const { onDeselect } = this.props;
        if (onDeselect) onDeselect(value, option);
    };

    /**
     * 失焦控制
     */
    onBlurHandler = () => {
        const { onBlur, value } = this.props;
        if (onBlur) onBlur(value);
    };

    /**
     * 静态数据展示处理
     * @param val
     */
    adaptHandler = (val: any) => {
        const { mode, options } = this.props;
        const isMultiple = mode === 'multiple';
        const display = options && options.filter(({ value }: iOption) => isMultiple ? (val || []).includes(value) : val === value);
        return (display && display.length) && (
            isMultiple
                ? display.map(({ label }: iOption) => label).join(' / ')
                : display[0].label
        );
    };
    addItem = async () => {
        const { addOption } = this.props;
        const { name } = this.state;
        if (!name) return;
        await addOption(this.state.name);
    };
    onNameChange = (event: any) => {
        event.stopPropagation();
        this.setState({
            name: event.target.value,
        });
    }
    onAddFocus = () => [
        this.setState({
            open: true
        })
    ]
    onDropdownVisibleChange = (open: Boolean) => {
        const { inputOnFocus } = this.state;
        this.setState({
            open: inputOnFocus || open
        });
    }
    render() {
        const { open } = this.state;
        const { inputPlaceholder, placeholder, options, allowClear, disabled, getPopupContainer, size, staticView, initialValue, value, mode, link, readOnly, dropdownStyle } = this.props;
        return (staticView && disabled || readOnly)
            ? <StaticView display={value || initialValue} link={link} adaptFn={this.adaptHandler} />
            : <div ref={(ctx: HTMLElement) => this.select = ctx} style={{ position: 'relative' }}>
                <Select onChange={this.onChangeHandler}
                    dropdownStyle={dropdownStyle}
                    onSelect={this.onSelectHandler}
                    onBlur={this.onBlurHandler}
                    onDeselect={this.onDeselectHandler}
                    placeholder={placeholder}
                    getPopupContainer={getPopupContainer && (() => this.select)}
                    allowClear={allowClear}
                    disabled={disabled}
                    value={value}
                    size={size}
                    mode={mode}
                    open={open}
                    onDropdownVisibleChange={this.onDropdownVisibleChange}
                    dropdownRender={menu => (
                        <div>
                            {menu}
                            <Divider style={{ margin: '4px 0' }} />
                            <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }} onMouseLeave={() => { this.setState({ inputOnFocus: false }); }}>
                                <Input style={{ flex: 'auto' }} onChange={this.onNameChange} placeholder={inputPlaceholder} onFocus={() => { this.setState({ inputOnFocus: true }); }} />
                                <a
                                    style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }} onFocus={() => { this.setState({ inputOnFocus: true }); }}
                                    onClick={this.addItem}
                                >
                                    <Icon className="anticon-add" style={{ fontSize: 18, color: '#1296db' }} />
                                </a>
                            </div>
                        </div>
                    )}
                >
                    {options && options.map((item: any, index: number) => {
                        return item.hasOwnProperty('value')
                            ? <Option key={item.value + index} value={item.value} disabled={item.disabled} className={item.className} style={{ verticalAlign: "middle", width: "100%" }}>
                                {item.label}
                                {item.selectedPoint
                                    ?
                                    <CheckOutlined style={{ color: "#096dd9", marginTop: "8px", float: "right" }} />
                                    :
                                    null
                                }
                            </Option>
                            : <Option key={`form-sl-op-${index}`} value={item}>{item + 1}</Option>;
                    })}
                </Select>
            </div>;
    }
}
